import Benchmarks from '@/language/pt/Benchmarks';
import Charts from '@/language/pt/Charts';
import Layout from '@/language/pt/Layout';
import StCompanySelection from '@/language/pt/StCompanySelection';
import StSystemNavigationDrawer from '@/language/pt/StSystemNavigationDrawer';
import Setup from '@/language/pt/Setup';

export default {
  Benchmarks,
  Charts,
  Layout,
  StCompanySelection,
  StSystemNavigationDrawer,
  Setup,
};
